import * as React from 'react';
import SectionHeader from '@able/react/dist/SectionHeader';
import { IOrderSummarySection } from '@applications/order-tracker/config/order-tracker-new-common/types';

export const OrderSummarySection = (props: IOrderSummarySection) => {
    if (!props.title) {
        return (
            <></>
        );
    } else {
        return (
            <section>
                <SectionHeader
                    title={props.title}
                    headingElement="h3"
                    variantLevel="Level2"
                    subtitle=""
                />
                {
                    props.descriptionGroup
                }
            </section>
        );
    }

};
